module.exports = __webpack_public_path__ + "img/advantage3.8f411e1f.png";